<template>
  <ul class="exhibitedWork-list">
    <li class="exhibitedWork" v-for="exhibitedWork in exhibitedWorks" :key="exhibitedWork.id">
      <span>Cat. n° {{exhibitedWork.number}} :</span>

      <span v-if="exhibitedWork.title" class="title">{{exhibitedWork.title}}</span>
      <span v-if="exhibitedWork.subtitle" class="subtitle">{{exhibitedWork.subtitle}}</span>
      <span v-if="!exhibitedWork.title">{{$t('pages.results.titleUnknown')}}</span>
      <span v-if="exhibitedWork.translation_title">[{{exhibitedWork.translation_title}}]</span>
      <span v-if="exhibitedWork.category">, {{exhibitedWork.category}}.</span>

      <span v-if="exhibitedWork.year_c1">{{exhibitedWork.year_c1}}, </span>
      <span v-if="exhibitedWork.city_c">{{exhibitedWork.city_c}}</span>
      <span v-if="exhibitedWork.year_c1 || exhibitedWork.city_c">.</span>

      <span v-if="exhibitedWork.size">{{$t('pages.results.size')}} : {{exhibitedWork.size}}.</span>
      <span v-if="exhibitedWork.medium">{{$t('pages.results.medium')}} : {{exhibitedWork.medium}}.</span>

      <span v-if="exhibitedWork.is_reproduced_in_catalog == 't'">
        {{$t('pages.results.exhibitedWorkReproducedInCatalog')}}
      </span>

      <span v-if="exhibitedWork.owner">
         {{$t('pages.results.owner')}} : {{exhibitedWork.owner}}<span v-if="exhibitedWork.city_o">, {{exhibitedWork.city_o}}</span>.
      </span>

      <span v-if="exhibitedWork.notes">{{$t('pages.results.notes')}} : {{exhibitedWork.notes}}.</span>
    </li>
  </ul>
</template>

<script>

export default {
  name: 'exhibitedWorks',
  props: ['exhibitedWorks']
}
</script>
<style>
.exhibitedWork-list {
  padding: 0
}
.exhibitedWork {
  list-style-type: none;
  margin-bottom: .5rem;
}
.exhibitedWork .title,
.exhibitedWork .subtitle {
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/components/ExhibitedWork/ExhibitedWorks.vue